import React, {
  Component,
  Dispatch,
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./RoundMenu.module.css";
import AnimateComponent from "../WaveShow/animatecomponent";
import EagleILogo from "../../assets/Eagle_I_Logo.png";
import { updateMapCenter, updateMapZoom } from "../../mainLayer/MainLayer";
import { ThemeProvider, useTheme } from "../../theme/ThemeContext";
import { useMenu } from "../../roundMenuContext/roundMenuContext";

export var longCoordinate = 80.7718;
  export var latCoordinate = 7.873;
  
  let isOpenJavis: boolean = false;
  
  // Types
  type PosisionType = {
	id: number;
	x: number;
	y: number;
	angle: number;
	zIndex: number;
	uid: string;
	scale: number;
	border: string;
	shadow: string;
	bgColor: string;
  };
  
  type MenuItemType = {
	text: string;
	bgImage:ReactElement<any, any>;
  };
  
  type PropsTypeMenu = {
	circleRedious: number;
	menuItemWidth: number;
	menuItemHeight: number;
	itemCount: number;
	offset: number;
	selectScale: number;
	leftArrow?: string;
	rightArrow?: string;
	circleBg?: string;
	itemData: Array<MenuItemType>;
	voiceRecognitionValue: (value: string) => void;
	openConsole: (value: boolean) => void;

	// New
	setVoiceCommand: Dispatch<React.SetStateAction<string>>
  };
  
  type PropsTypeItem = {
	menuItemWidth: number;
	menuItemHeight: number;
	itemX: number;
	itemY: number;
	id: number;
	zIndex: number;
	uid: string;
	scale: number;
	border: string;
	itemData: MenuItemType;
	shadow: string;
	bgColor: string;
	closeEnable: boolean;
  };
  
  function RoundMenu({
	circleRedious,
	menuItemWidth,
	menuItemHeight,
	itemCount,
	offset,
	selectScale,
	leftArrow,
	rightArrow,
	circleBg,
	itemData,
	voiceRecognitionValue,
	openConsole,

	// New
	setVoiceCommand
  }: PropsTypeMenu) {
	// Menu status(Open or Close)
	const [isClose, setIsClose] = useState<boolean>(true);
	// const [isOpenJavis, setIsOpenJavis] = useState<boolean>(false);
	// For Mouse is on the menu or not
	const [isMouseOnMenu, setIsMouseOnMenu] = useState<boolean>(false);
	const { theme } = useTheme();
  
	let touchSide: string = "";
	let startLocation: number = 0;
  
	// Mouse wheel event listner callback
	const mouseWheelEvent = useCallback((event: any) => {
	  if (event.wheelDeltaY > 0 && isClose) {
		rotateLeft()
	  } else if (event.wheelDeltaY < 0 && isClose) {
		rotateRight();
	  }
	}, []);
  
	let currentLocation = 0;
	// Touch move event listner callback
	const touchMove = useCallback((event: TouchEvent) => {
	  event.preventDefault();
  
	  let newLocation = Math.round(event.changedTouches[0].pageX);
  
	  if (currentLocation + 10 > newLocation) {
		touchSide = "left";
	  } else if (currentLocation + 10 < newLocation) {
		touchSide = "right";
	  } else {
		touchSide = "click";
	  }
	}, []);
  
	// Mouse enter event listner callback
	const mouseEnter = useCallback((event: MouseEvent) => {
	  setIsMouseOnMenu(true);
	}, []);
  
	// Touch start event listner callback
	const touchStart = useCallback((event: TouchEvent) => {
	  currentLocation = Math.round(event.touches[0].clientX);
	  setIsMouseOnMenu(true);
	}, []);
  
	// Mouse leave event listner callback
	const mouseLeave = useCallback((event: MouseEvent) => {
	  setIsMouseOnMenu(false);
	}, []);
  
	// Touch end event listner callback
	const touchEnd = useCallback((event: TouchEvent) => {
	  if (touchSide === "left") {
		rotateLeft();
	  } else if (touchSide === "right") {
		rotateRight();
	  }
  
	  startLocation = 0;
	  touchSide = "";
	  setIsMouseOnMenu(false);
	}, []);
  
	// Item clicked event listner
	const clickItem = useCallback((event: any) => {
	  let selectPosision = 0;
	  let centerPosision = 0;
	  let lastPosision = elementPosisions.length - 1;
	  let currentAngle = 0;
  
	  const itemX = Number(
		new WebKitCSSMatrix(event.currentTarget?.style.transform).m41.toFixed(2)
	  );
  
	  elementPosisions.forEach((item, i) => {
		if (item.angle === 90) {
		  centerPosision = item.id;
		}
		if (item.x === itemX) {
		  currentAngle = item.angle;
		}
	  });
  
	  elementPosisions.forEach((item, i) => {
		if (item.angle === currentAngle) {
		  selectPosision = item.id;
		}
	  });
  
	  if (currentAngle < 90) {
		for (let x = 0; x < centerPosision - selectPosision; x++) {
		  setTimeout(rotateRight, x * 150);
		}
	  } else if (currentAngle > 90) {
		for (
		  let x = 0;
		  x < centerPosision - (lastPosision - selectPosision);
		  x++
		) {
		  setTimeout(rotateLeft, x * 150);
		}
	  }
	}, []);
  
	const selectColor = (theme: string): string => {
	  if (theme === "light") {
		return "rgb(45, 140, 166)";
	  } else if (theme === "classic") {
		return "orange";
	  } else if (theme === "dark") {
		return "rgb(172, 122, 31)";
	  } else if (theme === "darkblue") {
		return "orange";
	  }
	  // Default color if none of the above matches
	  return "gray";
	};
  
	const selectbgColor = (theme: string): string => {
	  if (theme === "light") {
		return "rgb(113, 197, 226)";
	  } else if (theme === "classic") {
		return "rgba(255, 255, 255, 0.4)";
	  } else if (theme === "dark") {
		return "rgba(49, 49, 49, 0.856)";
	  } else if (theme === "darkblue") {
		return "rgba(49, 49, 49, 0.856)";
	  }
	  // Default color if none of the above matches
	  return "gray";
	};
  
	// Function for calculate posisions
	function calculateItemPosisions(): Array<PosisionType> {
	  // Posision List
	  const posisions: Array<PosisionType> = [];
  
	  // If item count is even
	  if (itemCount % 2 === 0) {
	  }
	  // If item count is odd
	  else if (itemCount % 2 === 1) {
		// Get current angle
		let currentAngle: number = 0;
		// Calculate angle between items
		const itemAngle: number = 90 / ((itemCount - 1) / 2); // TODO: Make dynamic
		// Angle after pass 90deg
		let rightAngle: number = itemAngle;
  
		// Loop all items
		for (let i: number = 0; i < itemCount; i++) {
		  // Center item (90deg)
		  if (i === (itemCount - 1) / 2) {
			// Set current angle to 90deg
			currentAngle = 90;
			// Set posisions
			posisions.push({
			  id: i,
			  x: 0,
			  y: circleRedious + offset,
			  angle: currentAngle,
			  zIndex: 0,
			  uid: `${i}`,
			  scale: selectScale,
			  border: "1px solid rgba(255, 255, 255, 0.3)",
			  shadow: "0px 0px 5px 2px rgba(0,0,0,0.88)",
			  bgColor: `var(--leftside-button-bg-color)`,
			});
			// Increse angle
			currentAngle += itemAngle;
		  } else {
			// If angle greater than 90 deg
			if (currentAngle > 90) {
			  // Set item posision
			  posisions.push({
				id: i,
				x: Number(
				  (
					(circleRedious + offset) *
					Math.sin((Math.PI / 180) * rightAngle)
				  ).toFixed(2)
				),
				y: Number(
				  (
					(circleRedious + offset) *
					Math.cos((Math.PI / 180) * rightAngle)
				  ).toFixed(2)
				),
				angle: currentAngle,
				zIndex: 0,
				uid: `${i}`,
				scale: 1,
				border: "1px solid rgba(255, 255, 255, 0.3)",
				shadow: "0px 0px 9px 1px rgba(0,0,0,0.88)",
					   bgColor: `var(--background-color)`
				,
			  });
			  // Increce right angle
			  rightAngle += itemAngle;
			  // Increse current angle
			  currentAngle += itemAngle;
			} else {
			  // Set item posision
			  posisions.push({
				id: i,
				x: Number(
				  (
					(circleRedious + offset) *
					Math.cos((Math.PI / 180) * currentAngle)
				  ).toFixed(2)
				),
				y: Number(
				  (
					(circleRedious + offset) *
					Math.sin((Math.PI / 180) * currentAngle)
				  ).toFixed(2)
				),
				angle: currentAngle,
				zIndex: 0,
				uid: `${i}`,
				scale: 1,
				border: "1px solid rgba(255, 255, 255, 0.3)",
				shadow: "0px 0px 9px 1px rgba(0,0,0,0.88)",
				bgColor: `var(--background-color)`,
			  });
			  // Increse current angle
			  currentAngle += itemAngle;
			}
		  }
		}
	  } else {
		// Raise Error
	  }
  
	  // Fix values in posision
	  posisions.forEach((item) => {
		// If angle between 0 and 90 set x values as minus
		item.angle >= 0 && item.angle < 90
		  ? (item.x = item.x * -1)
		  : (item.x = item.x);
		// If angle 0 or 180 set valus as its and others set to minus
		item.y === 0 || item.y === 180
		  ? (item.y = item.y)
		  : (item.y = item.y * -1);
	  });
  
	  let indexCount = 500;
	  // Set z Index
	  posisions.forEach((item) => {
		if (item.angle >= 0 && item.angle < 90) {
		  item.zIndex = indexCount;
		  indexCount++;
		} else if (item.angle === 90) {
		  item.zIndex = indexCount;
		  indexCount--;
		} else if (item.angle > 90 && item.angle <= 180) {
		  item.zIndex = indexCount;
		  indexCount--;
		}
	  });
  
	  // Return array
	  return posisions;
	}
  
	// All item posisions
	const elementPosisions: Array<PosisionType> = calculateItemPosisions();
  
	// Rotet menu left
	function rotateLeft(): void {
	  // Get element ids
	  let elements: Array<HTMLElement | null> = [];
	  // Set elements by id
	  elementPosisions.forEach((item) => {
		elements.push(document.getElementById(item.uid));
	  });
  
	  for (let i = 0; i < elements.length; i++) {
		const itemX = Number(
		  new WebKitCSSMatrix(elements[i]?.style.transform).m41.toFixed(2)
		);
  
		for (let x = 0; x < elementPosisions.length; x++) {
		  if (itemX === elementPosisions[0].x) {
			elements[i]!.style.transform = `translate(${
			  elementPosisions[elementPosisions.length - 1].x
			}px, ${elementPosisions[elementPosisions.length - 1].y}px) scale(${
			  elementPosisions[0].scale
			})`;
			elements[i]!.style.zIndex = `${elementPosisions[0].zIndex}`;
			elements[i]!.style.border = `${elementPosisions[0].border}`;
			elements[i]!.style.backgroundColor = `${elementPosisions[0].bgColor}`;
		  } else if (itemX === elementPosisions[x].x) {
			elements[i]!.style.transform = `translate(${
			  elementPosisions[x - 1].x
			}px, ${elementPosisions[x - 1].y}px) scale(${
			  elementPosisions[x - 1].scale
			})`;
			elements[i]!.style.zIndex = `${elementPosisions[x - 1].zIndex}`;
			elements[i]!.style.border = `${elementPosisions[x - 1].border}`;
			elements[i]!.style.backgroundColor = `${
			  elementPosisions[x - 1].bgColor
			}`;
		  }
		}
	  }
	}
  
	// Rotet menu right
	function rotateRight(): void {
	  // Get element ids
	  let elements: Array<HTMLElement | null> = [];
	  // Set elements by id
	  elementPosisions.forEach((item) => {
		elements.push(document.getElementById(item.uid));
	  });
  
	  for (let i = 0; i < elements.length; i++) {
		const itemX = Number(
		  new WebKitCSSMatrix(elements[i]?.style.transform).m41.toFixed(2)
		);
  
		for (let x = 0; x < elementPosisions.length - 1; x++) {
		  if (itemX === elementPosisions[elementPosisions.length - 1].x) {
			elements[
			  i
			]!.style.transform = `translate(${elementPosisions[0].x}px, ${elementPosisions[0].y}px) scale(${elementPosisions[0].scale})`;
			elements[i]!.style.zIndex = `${elementPosisions[0].zIndex}`;
			elements[i]!.style.border = `${elementPosisions[0].border}`;
			elements[i]!.style.backgroundColor = `${elementPosisions[0].bgColor}`;
		  } else if (itemX === elementPosisions[x].x) {
			elements[i]!.style.transform = `translate(${
			  elementPosisions[x + 1].x
			}px, ${elementPosisions[x + 1].y}px) scale(${
			  elementPosisions[x + 1].scale
			})`;
			elements[i]!.style.zIndex = `${elementPosisions[x + 1].zIndex}`;
			elements[i]!.style.border = `${elementPosisions[x + 1].border}`;
			elements[i]!.style.backgroundColor = `${
			  elementPosisions[x + 1].bgColor
			}`;
		  }
		}
	  }
	}
  
	// Menu close function
	function menuClose(): void {
	  // Get element ids
	  let elements: Array<HTMLElement | null> = [];
	  // Set elements by id
	  elementPosisions.forEach((item) => {
		elements.push(document.getElementById(item.uid));
	  });
  
	  // Set Posision to base
	  elements.forEach((item, i) => {
		item!.style.transform = `translate(0, 0)`;
		item!.style.border = `none`;
		item!.style.visibility = "hidden";
	  });
  
	  const circle = document.getElementById("menuCircle");
	  const circleCover = document.getElementById("cover");
	  const menuContainer = document.getElementById("menuContainer");
  
	  menuContainer!.style.transform = `scale(0.5)`;
  
	  setIsClose(true);
	}
  
	// Menu open function
	function menuOpen(): void {
	  // Get element ids
	  let elements: Array<HTMLElement | null> = [];
	  // Set elements by id
	  elementPosisions.forEach((item) => {
		elements.push(document.getElementById(item.uid));
	  });
  
	  elements.forEach((item, i) => {
		item!.style.transform = `translate(${elementPosisions[i].x}px, ${elementPosisions[i].y}px) scale(${elementPosisions[i].scale})`;
		item!.style.zIndex = `${elementPosisions[i].zIndex}`;
		item!.style.border = `${elementPosisions[i].border}`;
		item!.style.visibility = "visible";
	  });
  
	  const circle = document.getElementById("menuCircle");
	  const circleCover = document.getElementById("cover");
	  const menuContainer = document.getElementById("menuContainer");
  
	  menuContainer!.style.transform = `scale(1)`;
  
	  setIsClose(false);
	}
  
	// Runs only on first render
	useEffect(() => {
	  const menuContainer = document.getElementById("menuContainer");
  
	  menuContainer?.addEventListener("mouseenter", mouseEnter);
	  menuContainer?.addEventListener("touchstart", touchStart);
	  menuContainer?.addEventListener("mouseleave", mouseLeave);
	  menuContainer?.addEventListener("touchend", touchEnd);
  
	  // Get element ids
	  let elements: Array<HTMLElement | null> = [];
	  // Set elements by id
	  elementPosisions.forEach((item) => {
		elements.push(document.getElementById(item.uid));
	  });
  
	  elements.forEach((item, i) => {
		item?.addEventListener("click", clickItem);
	  });
  
	  // Set default menu status base on close
	  isClose ? menuClose() : menuOpen();
	}, []);
  
	useEffect(() => {
	  const menuContainer = document.getElementById("menuContainer");
  
	  if (isMouseOnMenu) {
		menuContainer?.addEventListener("mousewheel", mouseWheelEvent);
		menuContainer?.addEventListener("touchmove", touchMove);
	  } else {
		menuContainer?.removeEventListener("mousewheel", mouseWheelEvent);
		menuContainer?.addEventListener("touchmove", touchMove);
	  }
	}, [isMouseOnMenu]);
  
	const [value, setValue] = useState<string>("");
  
	const handleButtonClick = (value: string) => {
	  	setValue(value);
	};
  
	const [content, setContent] = useState<string>(""); /* Click and Hold Wave to Speak... */
	const waveBtnRef = useRef<HTMLDivElement>(null);
	const contentRef = useRef<string>(""); // Use a ref to store the latest content value
	const [isListening, setIsListening] = useState<boolean>(false);
  
	// Speech Synthesis to speak out text
	const speak = (text: string) => {
		const textSpeak = new SpeechSynthesisUtterance(text);
		textSpeak.rate = 1;
		textSpeak.volume = 1;
		textSpeak.pitch = 1;
		textSpeak.onend = () => {
			if (isOpenJavis) 
			{
				startListening();
			} 
			else 
			{
				stopListening();
			}
		};
		window.speechSynthesis.speak(textSpeak);
	};
  











	// Speech Recognition Setup
	const recognition = useRef<SpeechRecognition | null>(null);
  
	const speechMap = new Map([
	  ["open wind player", "open wind layer"],
	  ["open wind layer", "open wind layer"],
	  ["Open Winner", "open wind layer"],
	  ["open vilay", "open wind layer"],
	  ["open window", "open wind layer"],
	  ["wind", "open wind layer"],
	  ["open Bin layer", "open wind layer"],
	  ["close window", "close wind layer"],
	  ["close screen layer", "close wind layer"],
	  ["close window layer", "close wind layer"],
	  ["cross wind layer", "close wind layer"],
	  ["close win", "close wind layer"],
	  ["play timeline", "play timeline"],
	  ["timeline play", "play timeline"],
	  ["play time like", "play timeline"],
	  ["stop timeline", "stop timeline"],
	  ["open river sensor","open river sensors"],
	  ["open river","open river sensors"],
	  ["open rever Sensor","open river sensors"],
	  ["open rivers in","open river sensors"],
	  ["rivers in","open river sensors"],
	  ["open reverse sensor","open river sensors"],
	  ["open reverse sensors","open river sensors"],
	  ["open reverse","open river sensors"],
	  ["Cross River sensor","close river sensors"],
	  ["close reverse sensor","close river sensors"],
	  ["close reverse Sensex","close river sensors"],
	  ["close river sensors","close river sensors"],
	  ["close river","close river sensors"],
	]);
  
	useEffect(() => {
		// Initialize SpeechRecognition
		const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
		if (SpeechRecognition) 
		{
			recognition.current = new SpeechRecognition();
			recognition.current!.onresult = (event: SpeechRecognitionEvent) => {
				const currentIndex = event.resultIndex;
				const transcript = event.results[currentIndex][0].transcript;
				setContent(transcript);
				contentRef.current = transcript;
		
				//takeCommand(transcript.toLowerCase());
				//props.voiceRecognitionValue(transcript.toLowerCase());
			};

			recognition.current.onend = () => {
				// When recognition ends, send the final transcript to the parent
				const recognizedCommand = contentRef.current.toLowerCase(); // Normalize for better matching
				const commandValue = speechMap.get(recognizedCommand);
				//console.log(">>>>> Voice: ", contentRef.current)
				//console.log(">>>>> Command Value: ", commandValue)

				if (commandValue) 
				{
					// If a valid command is found, use it for voiceRecognitionValue and takeCommand
					voiceRecognitionValue(commandValue);
					takeCommand(commandValue);
				} 
				else 
				{
					voiceRecognitionValue(contentRef.current);
					takeCommand(contentRef.current);
				}
			};
	  	}
	}, [content, setContent, contentRef.current, latCoordinate, longCoordinate]);
  
	useEffect(() => {
	  // if (!isClose) {
	  //   startListening();
	  // } else {
	  //   stopListening();
	  // }
	}, [isClose]);
  
	useEffect(() => {}, [isOpenJavis]);
  
	const stopListening = () => {
		if (recognition.current && isListening)
		{
			recognition.current.stop();
		}
		setIsListening(false);
  		voiceRecognitionValue("");
	};
  
	const handleMouseDown3JS = () => {
		startListening();
		openConsole(true);
	};
  
	const handleMouseUp3JS = () => {
	  	stopListening();
	};
  
	const fetchCountryData = async (countryName: string) => {
		try 
		{
			const response = await fetch(`https://restcountries.com/v3.1/name/${countryName}`);
	
			if (!response.ok) 
			{
				return null;
			}
	
			const data = await response.json();
	
			if (data && data.length > 0) 
			{
				const country = data[0];
				return {
					name: country.name.common,
					lat: country.latlng[0],
					long: country.latlng[1],
					zoom: 5,
				};
			}
			return null;

		} 
		catch (error) 
		{
			return null;
		}
	};
  
	const extractCountryAndZoom = (message: string) => {
		// Use regex to find the zoom number if the message contains the word 'zoom'
		const zoomMatch = message.match(/zoom (\d+)/i);
		const zoomLevel = zoomMatch ? parseInt(zoomMatch[1], 10) : 4;
	
		// Remove the 'zoom' part and extract the country name
		const countryName = message.replace(/zoom \d+/i, "").trim();
	
		return { countryName, zoomLevel };
	};
  
	const extractZoomOnly = (message: string) => {
		// Check if the message contains only a zoom command
		const zoomMatch = message.match(/zoom (\d+)/i);
		return zoomMatch ? parseInt(zoomMatch[1], 10) : null;
	};
  
	const takeCommand = async (message: string) => {
		// First, check if the message is only a zoom command
		const zoomLevel = extractZoomOnly(message);
	
		if (zoomLevel !== null) 
		{
			// If zoom is found, apply it to the current map position
			speak(`Setting zoom level to ${zoomLevel}`);
			updateMapZoom(zoomLevel); // Assuming you have an `updateMapZoom` function
			return;
		}
	
		/* if (message.includes("hey") || message.includes("hello")) 
		{
			speak("Hello Sir, How May I Help You?");
			return;
		} */
	
		const { countryName, zoomLevel: countryZoomLevel } = extractCountryAndZoom(message);
	
		const countryDetails = await fetchCountryData(countryName);
	
		if (countryDetails) 
		{
			if (!isOpenJavis /* || message === "" */) 
			{
				speak("");
			} 
			else 
			{
				speak(`Showing the map of ${countryDetails.name} with zoom level ${countryZoomLevel}`);
				updateMapCenter(countryDetails.long, countryDetails.lat, countryZoomLevel); // Use the parsed zoom level
			}
		} 
		else 
		{
			if (message === "open wind layer" || message === "open river sensors" || message === "close wind layer" || message === "close river sensors"|| message === "play timeline"|| message === "stop timeline") 
			{
				speak(message);
			} 
			else 
			{
				if (!isOpenJavis || message === "") 
				{
					speak("");
				} 
				else 
				{
					setVoiceCommand(contentRef.current)
					speak("");
					//speak(`Sorry, I couldn't find any information`);
				}
			}
		}
		//stopListening();
	};
  
	const startListening = () => {
		contentRef.current = "";
		if (recognition.current) 
		{
			setIsListening(true);
			recognition.current.start();
		} 
		else 
		{
			speak("Speech recognition is not supported in this browser.");
		}
	};
  
	return (
		<div className={styles.menuContainer} id="menuContainer" style={{ width: `${circleRedious * 2}px`, height: `${circleRedious * 2}px` }}>
			<div className={styles.menuCircle} id="menuCircle" style={{ width: `${circleRedious * 2}px`, height: `${circleRedious / 2}px`, marginLeft: "50px"}}>
			{calculateItemPosisions().map((item) => (
				<Item
				key={item.id}
				menuItemWidth={menuItemWidth}
				menuItemHeight={menuItemHeight}
				itemX={item.x}
				itemY={item.y}
				id={item.id}
				zIndex={item.zIndex}
				uid={item.uid}
				scale={item.scale}
				border={item.border}
				itemData={itemData[item.id]}
				shadow={item.shadow}
				bgColor={item.bgColor}
				closeEnable={isClose}
				/>
			))}
			</div>
				{!isClose && (
					<div
						className={styles.cover}
						id="cover"
						onClick={() => {
							menuClose();
							// startListening();
							stopListening();
							openConsole(false);
							// setIsOpenJavis(false);
							isOpenJavis = false;
						}}
							// onMouseDown={handleMouseDown3JS}
							// onMouseUp={handleMouseUp3JS}
				
							style={{
							width: `${circleRedious * 2}px`,
							height: `${circleRedious * 2}px`,
							marginLeft: "50px",
						}}>
					<AnimateComponent sendValue={handleButtonClick} />
				</div>
				)}
		
				{isClose && (
					<button
						className={`slider-menu-btn ${theme}`}
						onClick={() => {
							menuOpen();
							startListening();
							openConsole(true);
							isOpenJavis = true;
							//setIsOpenJavis(true);
						}}>
						<img src={EagleILogo} width={"110%"} height={"80%"} />
					</button>
				)}
		</div>
	);
}
  export default RoundMenu;
  
  // Item
  function Item({
	menuItemWidth,
	menuItemHeight,
	itemX,
	itemY,
	id,
	zIndex,
	uid,
	scale,
	border,
	itemData,
	shadow,
	bgColor,
	closeEnable,
  }: PropsTypeItem) {
	const { menu, setMenuSelect  } = useMenu();
  
	const handleItemClick = (name: string) => {
  
  
	  
	  if(name === 'Wind')
	  {
		setMenuSelect('Wind')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  }else if(name === 'Temperature')
	  {
		setMenuSelect('Temperature')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Accumulated Rain')
	  {
		setMenuSelect('Accumulated Rain')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Air pressure')
	  {
		setMenuSelect('Air pressure')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Flood')
	  {
		setMenuSelect('Flood')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Early Warning')
	  {
		setMenuSelect('Early Warning')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Reported Incidents')
	  {
		setMenuSelect('Reported Incidents')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Satellites')
	  {
		setMenuSelect('Satellites')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'River Sensors')
	  {
		setMenuSelect('River Sensors')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  } else if(name === 'Air Quality')
	  {
		setMenuSelect('Air Quality')
		setTimeout(() => {
		  setMenuSelect('None')
		}, 100);
	  }
	}
  
	return (
	  <div
		id={uid}
		className={styles.item}
		key={id}
		onClick={(e) => handleItemClick(itemData?.text)}
		style={{
		  width: `${menuItemWidth}px`,
		  height: `${menuItemHeight}px`,
		  top: `calc(50% - ${menuItemHeight / 2}px)`,
		  left: `calc(50% - ${menuItemWidth / 2}px)`,
		  transform: `translate(${itemX}px, ${itemY}px) scale(${scale})`,
		  zIndex: `${zIndex}`,
		  border: `${border}`,
		  backgroundColor: `${bgColor}`,
		  boxShadow: `${shadow}`,
		  marginLeft: closeEnable ? `40px` : `0px`,
		}}
	  >
		{itemData?.bgImage}
		<span>{itemData.text}</span>
	  </div>
	);
  }
  
